import { Sparkle } from "@phosphor-icons/react";

const ITEMS = [
    "Healthcare Without Borders",
    "GCC",
    "United Kingdom",
    "Africa",
    "Central Asia",
    "Diagnosis to Recovery",
    "One Intelligent Journey",
    "Built in India, for the World",
];

export default function Marquee() {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div data-testid="editorial-marquee" className="relative border-y border-slate-100 bg-white py-6 overflow-hidden" aria-hidden="true">
            <div className="flex w-max animate-marquee items-center gap-10 whitespace-nowrap">
                {[0, 1].map((half) => (
                    <div key={half} className="flex items-center gap-10">
                        {row.map((item, i) => (
                            <span key={`${half}-${i}`} className="flex items-center gap-10">
                                <span className="font-heading text-sm font-semibold uppercase tracking-[0.3em] text-brand-blue/60">{item}</span>
                                <Sparkle size={12} weight="fill" className="text-brand-green/60" />
                            </span>
                        ))}
                    </div>
                ))}
            </div>
        </div>
    );
}
